<div class="funds-card">

    <div class="tabs">
        <button (click)="goDeposit()">{{'DEPOSIT' | translate}}</button>
        <button class="active">{{'CASHOUT' | translate}}</button>
    </div>

    <div class="content">
        <div>
            <div class="black_cover" *ngIf="paykassmaFailRes" (click)="closePaykassResPopfalse()"></div>
            <div class="popup_1 pop_sm" *ngIf="paykassmaFailRes">
                <span class="casino_pupop" (click)="closePaykassResPopfalse()"> <i class='fas fa-times'
                        style="color: #fff;"></i></span>
                <div class="soon font_16">
                    {{showMessage | translate}} <br> <br>
                    <div class="btn_comSoon_main" (click)="closePaykassResPopfalse()"> OK </div>
                </div>
            </div>
            <!-- <div *ngIf="!hideDeposit" class="min-height"></div> -->

            <!-- <p  class="deposit-highlight"><b style="color: #ff591e;font-size: 20px;">* </b>Cash out your winnings anytime from the Cashier by selecting Withdraw, choosing a payout method, and confirming the amount.</p> -->

            <div class="fd min-height" style="display: flex;justify-content: center;align-items: center;">
            <!-- <div class="fd min-height" *ngIf="hideDeposit" style="display: flex;justify-content: center;align-items: center;"> -->

                <div class="form-container bg_7 p_20">
                    <!-- <div class="form-image">
                    <img src="../../../../assets/siteImg/withdrawal_icon.webp" alt="crypto payment" />
                </div> -->

                    <div class="form-fields">
                        <div class="errorMSG" *ngIf="interFalseRes">
                            <i class='fas fa-exclamation-triangle'></i>
                            <p>{{interFalseRes}}</p>
                        </div>

                        <!-- <div class="loader_div" *ngIf="isSpinner">
                            <span class="loader"></span>
                        </div> -->

                        <section class="fd payment-method p_l_15">
                            <form [formGroup]="criptoWithDrawalForm" (ngSubmit)="onWithdrawSubmit()">
                                <div class="fd p_lr_15">
                                    <div class="fd m_b_15">
                                        <input type="phone" class="styled-input bg_3"
                                            [placeholder]="'AMOUNT_MIN_1000_MAX_50000_RUPEES' | translate"
                                            formControlName="amount" min="1000" (keypress)="phonenum($event)" />
                                        <div class="text-danger"
                                            *ngIf="criptoWithDrawalForm.get('amount')?.invalid && criptoWithDrawalForm.get('amount')?.touched">
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('amount')?.errors?.['required']">
                                                {{'PLEASE_ENTER_AMOUNT' | translate}}
                                            </span>
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('amount')?.errors?.['pattern']">
                                                Amount must be a number
                                            </span>
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('amount')?.errors?.['min']">
                                                {{'MAXIMUM_1000' | translate}}
                                            </span>
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('amount')?.errors?.['max']">
                                                {{'MAXIMUM_50000' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="fd m_b_15">
                                        <input type="text" class="styled-input bg_3"
                                            [placeholder]="'ACCOUNT_NAME' | translate" formControlName="name"
                                            (keypress)="accountName($event)" />
                                        <div class="text-danger"
                                            *ngIf="criptoWithDrawalForm.get('name')?.invalid && criptoWithDrawalForm.get('name')?.touched">
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('name')?.errors?.['required']">
                                                {{'ACCOUNT_NAME_IS_REQUIRED' | translate}}
                                            </span>
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('name')?.errors?.['pattern']">
                                                {{'ACCOUNT_NAME_IS_REQUIRED' | translate}}
                                            </span>

                                        </div>
                                    </div>
                                    <span class="note-pulse"><b>{{'NOTE' | translate}}:</b>
                                        {{'PLEASE_ENTER_NAME_AS_PER_BANK_RECORDS' | translate}}</span>
                                    <div class="fd m_b_15">
                                        <select [(ngModel)]="selectedRate" class="form-control"
                                            formControlName="accountType">
                                            <!-- <option disabled selected> Select </option> -->
                                            <option value="Nagad"> Nagad </option>
                                            <option value="Bkash"> Bkash </option>
                                            <!-- <option value="nagad_a"> nagad </option>
                                            <option value="bkash_a"> bkash </option> -->
                                            <!-- <option value="bkash_p2p"> bkashp2p </option> -->
                                            <!-- <option value="upay"> upay </option> -->
                                        </select>
                                    </div>
                                    <div class="fd m_b_15">
                                        <input type="phone" class="styled-input bg_3"
                                            [placeholder]="'ACCOUNT_NUMBER' | translate"
                                            formControlName="personalNumber" (keypress)="Accontnumber($event)" />
                                        <div class="text-danger"
                                            *ngIf="criptoWithDrawalForm.get('personalNumber')?.invalid && criptoWithDrawalForm.get('personalNumber')?.touched">
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('personalNumber')?.errors?.['required']">
                                                {{'PLEASE_ENTER_ACCOUNT_NUMBER' | translate}}
                                            </span>
                                            <span class="clr_f0"
                                                *ngIf="criptoWithDrawalForm.get('personalNumber')?.errors?.['pattern']">
                                                {{'PLEASE_ENTER_ACCOUNT_NUMBER' | translate}}

                                            </span>

                                        </div>
                                    </div>


                                    <div class="fd m_b_15 d-flex justify-content-center">
                                        <button type="submit" class="trans_btns"
                                            [disabled]="criptoWithDrawalForm.invalid || withdrawloader">
                                            <span  *ngIf="!withdrawloader"> {{'CASHOUT' | translate}}</span>  
                                            <span *ngIf="withdrawloader" class="loader-gif">
                                                <div class="spin">◌</div>
                                            </span>
                                        </button>

                                    </div>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
<!-- ******************** InterKasa Withdrawals End************************** -->
<div class="black_cover" *ngIf="sessionExpiresuccessPop" (click)="sessionExpiresuccessPopClose()"></div>
<div class="popup_1 pop_sm" *ngIf="sessionExpiresuccessPop">
    <span class="casino_pupop" (click)="sessionExpiresuccessPopClose()"> <i class='fas fa-times'></i></span>
    <div class="soon font_16">
        Thank you for showing interesting in Gambaji. Please contact your agent for Deposits and Withdrawal related
        queries.
        Keep Playing and make more money<br> <br>
        <button class="btn_comSoon" (click)="sessionExpiresuccessPopClose()"> OK </button>
    </div>
</div>




<!-- <div class="cover_profile" *ngIf="isSpinner">
    <div class="" *ngIf="isSpinner">
        <div class="video-bg"></div>

        <div class="loader-center">
            <img src="assets/siteImg/Gambaji.svg" class="logo-loader" />
        </div>
    </div>
</div> -->

<div class="marg"></div>